import { updateTOC } from "./counterSlice";

//import events from external files here.

import $ from "jquery";
import { rxhtmltag4jQuery } from "./rxhtmltag";
import { getUrlObj,parseMapToDOM } from "../../utils";
rxhtmltag4jQuery();

export function UpdateURL(
  selectedHref,
  dartSelectors,
  tag = "",
  fromClick = false
) {
  let XRefPath = selectedHref;
  let urlObj = getUrlObj();
  if (
    !selectedHref?.includes("#") &&
    urlObj.hash !== "" &&
    !urlObj.search.includes("sectionId")
  ) {
    XRefPath += urlObj.hash;
  } else if (tag !== "" && tag !== "H2") {
    XRefPath += "#" + tag;
  }

  if (selectedHref?.includes("../../")) {
    selectedHref = selectedHref.split("../../")[1];
  }
  selectedHref = selectedHref?.replace(/\.\.\//g, "");

  if (selectedHref?.includes("#")) {
    selectedHref = selectedHref.split("#")[0];
  }

  const domMap = parseMapToDOM(dartSelectors.map);
  const container_tg_toc_id = document.getElementById("tg_toc_id");
  const tocIdElm = container_tg_toc_id?.querySelector(
    `[href*="${selectedHref}"]`,
  );
  let tocPathJS = tocIdElm?.getAttribute("tocpath");
  let mpsPathJS = tocIdElm?.getAttribute("mpspath");
  if (mpsPathJS === undefined && selectedHref) {
    let section_id = selectedHref.split("-").slice(0, -1).join("-");
    const sectionToc = domMap?.querySelector('[href*="' + section_id + '"]');
    mpsPathJS = sectionToc?.getAttribute("mpspath");
  }
  if (mpsPathJS !== undefined) {
    mpsPathJS = mpsPathJS.replace(")", "").replace("(", "");
  }

  const selectedTopicEl = container_tg_toc_id?.querySelector(
    `[href*="${selectedHref}"]`,
  );

  let selectedTopicJS = selectedTopicEl?.getAttribute("href");

  let urlConfig = localStorage.getItem("darturl") === "1" ? tocPathJS : mpsPathJS;

  let currentHash = urlObj.href.replace(
    urlObj.protocol + "//" + urlObj.host,
    ""
  );
  // remove activeElm after enhacedcounter check
  const activeElm = domMap.getElementsByClassName("active");
  console.log("activeElm", activeElm);
  // ready to navigate
  // const redirectUrl = 
  processUrlUpdate(
    currentHash,
    urlConfig,
    dartSelectors,
    mpsPathJS,
    fromClick,
    selectedHref,
    window,
  );

  // Select all <xref> and <term> elements in the parsed DOM
  const elements = domMap.querySelectorAll('xref, term');

  // Loop and remove the "active" class from each
  elements.forEach(el => {
  el.classList.remove('active');
  });
  setTimeout(() => {dartSelectors.dispatch(
    updateTOC({ selectedTopic:selectedTopicJS, XRefPath, dartSelectors, tag })
  )})

}

function processUrlUpdate(
  currentHash,
  urlConfig,
  dartSelectors,
  mpsPath,
  fromClick,
  selectedHref,
  window,
  navigate
) {
  if (!currentHash || !urlConfig) {
    return;
  }
  if (currentHash.replace(/\//g, "") !== urlConfig.replace(/\//g, "")) {
    if (
      urlConfig ===
      "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=acute-gastroenteritis&guidelinename=Antibiotic&sectionId=toc_d1e1473#toc_d1e1438"
    ) {
      urlConfig =
        "/viewTopic?etgAccess=true&guidelinePage=Antibiotic&topicfile=acute-gastroenteritis&guidelinename=Antibiotic&sectionId=toc_d1e1455#toc_d1e1438";
    }

    if (dartSelectors.uxPlatform === "mobile") {
      let topicFileforMobile = mpsPath;
      topicFileforMobile = topicFileforMobile
        .split("topicfile")[1]
        .split("=")[1]
        .split("&")[0];
    }

    if (window.location.href.includes("topicTeaser")) {
      urlConfig = urlConfig.replace("viewTopic", "topicTeaser");

      setTimeout(() => {
        if (
          (parseInt($("topicref.active:last").attr("level")) > 2 &&
            $(".username").text() !== "") ||
          (parseInt($("topicref.active:last").attr("level")) == 1 &&
            $("topicref.active:last").text().includes("calculator"))
        ) {
          urlConfig = urlConfig.replace("topicTeaser", "viewTopic");
          window.location = urlConfig;
        } else {
          $(".tablesfigurestables").on("click", function () {
            window.location.href = $(this).attr("mpspath");
          });

          $(".tablesfiguresfigures").on("click", function () {
            window.location.href = $(this).attr("mpspath");
          });
        }
      }, 500);
    }

    if (
      window.location.href.toLowerCase().includes("calculator") &&
      window.location.href.includes("viewTopic")
    ) {
      setTimeout(() => {
        let calcURL = $('[classname="bodyContentDiv"] xref').attr("href");
        window.location = calcURL;
      }, 1000);
    }
    if (fromClick && !urlConfig) {
      const currentURL = window.location.href;
      const url = new URL(currentURL);
      const queryParameters = url.searchParams;
      const modifiedHref = selectedHref.replace(/^(\.\.\/)+/, "");
      const splitHref = modifiedHref.split("/");
      if (splitHref.length === 3) {
        const guidelinePage = splitHref[0];
        const topicFile = splitHref[1];
        const sectionId = splitHref[2].replace(/\.dita$/, "");
        queryParameters.set("guidelinePage", guidelinePage);
        queryParameters.set("topicfile", topicFile);
        queryParameters.set("sectionId", sectionId);
        const updatedUrl = `${url.pathname}?${queryParameters.toString()}#${sectionId}`;
        dartSelectors.navigate(updatedUrl);
      }
    } else { 
      if (urlConfig !== currentHash) {
        dartSelectors.navigate(urlConfig);
      }
    }
  }
}
//Move to separate file if there are a lot of functions.
//e.g. call this ditaTopicref.js for example and import above.
export function HandleTOCClick(dartSelectors) {
  $("concept>ditatitle, topic>ditatitle").on({
    click: function () {
      let selectedHref = $(this).closest("topicref").attr("href");
      const calculatorRoutes = {
                'Antibiotic/c_creatinine_clearance_calculator_for_adults.dita': '/calculator/ccbwcalc',
                'Antibiotic/c_glomerular_filtration_rate_GFR_calculator_for_children.dita': '/calculator/gfrcalc',
                'Antibiotic/Calculators/Gentamicin_initial_dose_calculator.dita': '/calculator/Gentamicin',
                'Antibiotic/Calculators/Tobramycin_initial_dose_calculator.dita': '/calculator/Tobramycin',
                'Antibiotic/Calculators/Amikacin_initial_dose_calculator.dita': '/calculator/Amikacin'
            };
      if (calculatorRoutes[selectedHref]) {
                dartSelectors.navigate(calculatorRoutes[selectedHref]);
      } else {
        UpdateURL(selectedHref, dartSelectors);
      }
    },
  });

  $("bookmap>ditatitle").on({
    click: function () {
      let currentElement = this;
      UpdateURL(
        $(currentElement).closest("bookmap").find("chapter:eq(0)").attr("href"),
        dartSelectors
      );
    },
  });
}
